import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { ArtifactStatus, ArtifactType, IArtifactDTO, VideoResolution } from '../../../../../../api/artifacts.dao';
import { artifactStatusLabel, artifactStyleByStatus, artifactTypeLabel, assetVideoType, webinarRecordingTypeLabel } from '../../../../../../constants/artifacts.constants';
import classNames from 'classnames';
import { PreviewKnovioArtifactButton } from '../../preview-artifact/preview-knovio-artifact-button';
import { DELETE_TEXT } from '../../../../../../constants/common-labels.constants';

interface Props {
    artifact: IArtifactDTO;
    deleteArtifactPermission: boolean;
    onDeleteArtifact: (assetMetadataId: number, meetingId: number, assetType: ArtifactType) => void;
    meetingId: number;
    onPreviewArtifact: () => void;
}

export const ArtifactPopoverPresentation = observer((props: Props): JSX.Element => {
    const {
        artifact,
        deleteArtifactPermission,
        onDeleteArtifact,
        meetingId,
        onPreviewArtifact,
    } = props;

    const {
        assetMetadataId,
        assetType,
        assetStatus,
        resolution,
        recordingType,
    } = artifact;

    const isPreviewButtonHidden = assetType !== ArtifactType.PASSPORT_REPLAY || assetStatus === ArtifactStatus.PENDING;

    return (
        <div className='artifact-popover'>
            <div className='artifact-popover__content'>
                <div className='artifact-popover__type'>
                    {artifactTypeLabel[assetType]}
                </div>
                {assetVideoType.includes(assetType) &&
                    <div className='artifact-popover__info'>
                        {VideoResolution[resolution] ?? webinarRecordingTypeLabel[recordingType] ?? (assetStatus === ArtifactStatus.NOT_AVAILABLE ? 'Default' : '')}
                    </div>
                }
                <div className={classNames('artifact-popover__type', artifactStyleByStatus[assetStatus])}>
                    {artifactStatusLabel[assetStatus]}
                </div>
                <PreviewKnovioArtifactButton onClick={onPreviewArtifact} hidden={isPreviewButtonHidden}/>
            </div>
            {deleteArtifactPermission &&
                <div className='popup-footer-remove-button artifact-popover__footer' onClick={() => onDeleteArtifact(assetMetadataId, meetingId, assetType)}>
                    <FormattedMessage {...DELETE_TEXT} />
                </div>
            }
        </div>
    );
});
